/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Proposals API
 * Moment's Proposals API allows Clients to manage optimization proposals.
 * OpenAPI spec version: 1.0.0
 */

export type TradeConstraintType = typeof TradeConstraintType[keyof typeof TradeConstraintType];


export const TradeConstraintType = {
  trade: 'trade',
} as const;
